import { createSlice ,createAsyncThunk } from "@reduxjs/toolkit";
import axious from "../../utils/axious";

// bunlar istenirse Thunk ile baska bir sayfada yapilabilridi 
// GET jobs
export const fetchJobs = createAsyncThunk(
  "job/fetchJobs",
  async () => {
    const response = await axious.get("/jobs");
    return response.data;
  }
);

// POST job
export const addJob = createAsyncThunk(
  "job/addJob",
  async (newJob) => {
    const response = await axious.post("/jobs", newJob);
    return response.data;
  }
);

// DELETE job
export const deleteJob = createAsyncThunk(
  "job/deleteJob",
  async (id) => {
    await axious.delete(`/jobs/${id}`);
    return id;
  }
);

export const updateJob = createAsyncThunk(
  "job/updateJob",
  async ({ id, updatedJob }) => { 
    const response = await axious.put(`/jobs/${id}`, updatedJob);
    return response.data;
  } 
);

const initialState = {
  jobs: [],
  isLoading: false,
  error: null,
};

const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
  },
   extraReducers: (builder) => {
    builder
      // fetchJobs
      .addCase(fetchJobs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // deleteJob
      .addCase(deleteJob.fulfilled, (state, action) => {
        state.jobs = state.jobs.filter(
          (job) => job.id !== action.payload
        );
      })
      // updateJob
      .addCase(updateJob.fulfilled, (state, action) => {
        const index = state.jobs.findIndex(
          (job) => job.id === action.payload.id
        );
        state.isLoading = false;
        if (index !== -1) {
          state.jobs[index] = action.payload;
        }
      })
      .addCase(addJob.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(addJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default jobSlice.reducer;